$(document).ready(function() {
	const header = document.getElementById('header');
	const desktopBreakpoint = 1280;

	function closeMobileNav() {
		$('#hamburger').removeClass('open');
		$('body, html').removeClass('no-scroll nav-open');
		header.classList.remove('open');
	}

	$('#hamburger').on('click', function() {
		$(this).toggleClass('open');
		$('body, html').toggleClass('no-scroll');
		$('body, html').toggleClass('nav-open');

		if (header.classList.contains('open')) {
			header.classList.remove('open');
		} else {
			header.classList.add('open');
			header.classList.remove('mini');
			header.classList.remove('mini');
		}
	});

	$(window).on('resize', function() {
		if (window.innerWidth >= desktopBreakpoint) {
			closeMobileNav();
		}
	});
});
